"use strict";
(function ($) {
	$("document").ready(function () {
		$('#edit_user_data_form').on('submit', function(e) {
			e.preventDefault();
			const edit_user_data_form = $("#edit_user_data_form");
			const formData = new FormData(edit_user_data_form[0]);
			const rest_endpoint = edit_user_data_form.attr('action');

			const request = $.ajax({
				url: rest_endpoint,
				method: "POST",
				data: formData,
				async: false,
				cache: false,
				contentType: false,
				processData: false,
				beforeSend: function (xhr) {
					xhr.setRequestHeader('X-WP-Nonce', edit_user_data_form.find('input[name="rest_auth_nonce"]').val());
				}
			});

			request.done(function (msg) {
				if(msg.error == 1){
					$('#registrationFailUserExistsModal').modal('toggle');
				}else{
					$('#editModal').modal('toggle');
					setTimeout(function(){
						window.location.reload();
					},1500);
				}
			});
			request.fail(function (jqXHR, textStatus) {
				$('#editFailModal').modal('toggle');
			});
		});

		$("#reset_password_action").on('click', function(e){
			e.preventDefault();
			$("#lost_password_form").trigger('submit');
		});
		$("#lost_password_form").on('submit', function(e){
			e.preventDefault();
			const lost_password_form = $("#lost_password_form");
			const formData = new FormData(lost_password_form[0]);
			const rest_endpoint = lost_password_form.attr('action');

			const request = $.ajax({
				url: rest_endpoint,
				method: "POST",
				data: formData,
				async: false,
				cache: false,
				contentType: false,
				processData: false
			});

			request.done(function (msg) {
				//Check you mailbox

			});
			request.fail(function (jqXHR, textStatus) {
				//Error code and error message
				//console.log(jqXHR, textStatus);
			});
		});
	});
})(jQuery);
